import { render } from "./FolderGrid.vue?vue&type=template&id=64c18cc9&scoped=true"
import script from "./FolderGrid.vue?vue&type=script&lang=js"
export * from "./FolderGrid.vue?vue&type=script&lang=js"

import "./FolderGrid.vue?vue&type=style&index=0&id=64c18cc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c18cc9"]])

export default __exports__